module.exports = __webpack_public_path__ + "img/Tailgater.505a8927.png";